import { render } from "./PublicNavbar.vue?vue&type=template&id=3fad6d64"
import script from "./PublicNavbar.vue?vue&type=script&lang=js"
export * from "./PublicNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__